module.exports = __webpack_public_path__ + "img/012-cleaning.815f8e2e.png";